import React from "react";
import "./appointment.css";

const AppointmentPage = () => {
  return (
    <div className="appointment-page page-content mt-5">
      {/* Updates Section */}
      <section className="updates-section">
        <h2>Latest Industry Updates</h2>

        <div className="updates-grid">
          <div className="update-card">
            <span className="tag">Industry News</span>
            <h3>Travel Industry Growth in 2026</h3>
            <p>
              New trends and opportunities are shaping the future of travel and
              hospitality across India and global markets.
            </p>
          </div>

          <div className="update-card">
            <span className="tag promo">Promotion</span>
            <h3>Exclusive Partner Promotions</h3>
            <p>
              Special promotional opportunities available for registered travel
              agents and industry partners.
            </p>
          </div>

          <div className="update-card">
            <span className="tag update">Update</span>
            <h3>Platform Feature Enhancements</h3>
            <p>
              New tools and features launched to improve networking, meetings,
              and business growth.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AppointmentPage;
